




import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service"
import {VrstaOdrzavanja} from "../services/BackendProxies";

@Component({})
export default class KorektivnoOdrzavanjeEditor extends Vue {
    odrzavanja = [];
    korektivnoOdrzavanje = [];
    @Prop() value!: string;

    model = '';

    @Watch('value') onValueChange(value) {
        this.model = value;
    }

    @Watch('model') onModelChange(value) {
        this.input(value);
    }

    @Emit() input(value) {
    }

    async created() {
        this.odrzavanja = await dataProxy.vratiVrsteOdrzavanja();
        const korektivnoOdrz = this.odrzavanja.filter(x => x.preventivno === false);
        korektivnoOdrz.unshift(VrstaOdrzavanja.fromJS({id: '', oznaka: '...'}));
        this.korektivnoOdrzavanje = korektivnoOdrz.map(x => ({id: x.id, text: `${x.oznaka} ${x.naziv || ''}`}));
        this.model = this.value;
    }
}
